import { Injectable } from '@angular/core';

@Injectable()
export class VanityUrlService {
  constructor() {}

  parseIdFromUniqueVesselString(vesselIdentifier: string): number {
    const strArray = vesselIdentifier.split('-');
    return Number.parseInt(strArray[strArray.length - 1]);
  }
}
